<template>
  <div class="homepagewide-layout">
    <HomepageLayout :wide-header="wideHeader" :heroDark="heroDark">
        <slot></slot>
    </HomepageLayout>
    <BottomNavigation  v-if="footer !== 'no'"></BottomNavigation>
  </div>
</template>

<script>
export default {
  props: {
    footer: String,
    wideHeader: String,
    heroDark: Boolean
  }
}
</script>

<style scoped lang="scss">
@import '~scss/colors';

.homepagewide-layout {
  display: block;
  background-color: $white;
}

</style>




// WEBPACK FOOTER //
// src/components/layout/HomepageWideLayout.vue